import React, { Component } from 'react'
import { Section, Input, Checkbox } from '../../../../components'
import { STRING } from '../../../../helpers'
import NumberFormat from 'react-number-format'
export default class HideLeadingBidAmount extends Component {
  render() {
    const {
      auctionType,
      formData,
      editRoleDetail,
      isErrHideLeadingBidAmount,
      isSetState,
    } = this.props

    return (
      <Section className="form-group">
        <label className="hide-leading-bid-when-bid-amount">
          Hide Leading Bid <br />
          When Bid Amount
          <br />
          Does Not Reach <br />
          Reserve Price
        </label>
        <Section className="form-group-control">
          <Section className="form-group-inner-wrapper">
            <Checkbox
              id="no_HideLeadingBidAmount"
              value="no_HideLeadingBidAmount"
              type="radio"
              name="no_HideLeadingBidAmount"
              checked={
                formData.step2.eventInformation.eventReservePrice
                  ? !formData.step2.eventInformation.is_HideLeadingBidAmount
                  : false
              }
              className="inline"
              disabled={
                !formData.step2.eventInformation.eventReservePrice ||
                !editRoleDetail
                  ? true
                  : false
              }
              onChange={e => {
                formData.step2.eventInformation.is_HideLeadingBidAmount = false
                isSetState({
                  formData,
                })
              }}
            >
              <div
                className={`checkbox-minimum-bid hide-leading-bid-when-bid-amount ${
                  (!formData.step2.eventInformation.eventReservePrice ||
                    !editRoleDetail) &&
                  'checkbox-is-error'
                }`}
                style={{ width: '105px' }}
              >
                No
              </div>
            </Checkbox>
            <Checkbox
              id="yes_HideLeadingBidAmount"
              value="yes_HideLeadingBidAmount"
              type="radio"
              name="yes_HideLeadingBidAmount"
              checked={
                formData.step2.eventInformation.eventReservePrice
                  ? formData.step2.eventInformation.is_HideLeadingBidAmount
                  : false
              }
              className="inline"
              disabled={
                !formData.step2.eventInformation.eventReservePrice ||
                !editRoleDetail
                  ? true
                  : false
              }
              onChange={e => {
                formData.step2.eventInformation.is_HideLeadingBidAmount = true
                isSetState({
                  formData,
                })
              }}
            >
              <div
                className={`checkbox-minimum-bid hide-leading-bid-when-bid-amount ${
                  (!formData.step2.eventInformation.eventReservePrice ||
                    !editRoleDetail) &&
                  'checkbox-is-error'
                }`}
              >
                Yes
              </div>
            </Checkbox>
          </Section>
          <Section className="message">
            {isErrHideLeadingBidAmount && STRING.INVALID}
          </Section>
        </Section>
      </Section>
    )
  }
}
